import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-leaderboard-tab',
  templateUrl: './leaderboard-tab.component.html',
})
export class LeaderboardTabComponent {
  @Input() isCiscoAdmin: boolean = false;
}
